var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3308_653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.65527 0.27832C6.16595 0.27832 3.32715 3.11712 3.32715 6.60645C3.32715 7.78538 3.65371 8.9359 4.27176 9.93405L9.29506 18.029C9.39129 18.1841 9.56081 18.2783 9.74313 18.2783C9.74453 18.2783 9.74591 18.2783 9.74731 18.2783C9.93122 18.2769 10.1011 18.1797 10.1956 18.022L15.0908 9.84855C15.6748 8.87149 15.9834 7.75039 15.9834 6.60645C15.9834 3.11712 13.1446 0.27832 9.65527 0.27832ZM14.1857 9.30708L9.73515 16.738L5.16818 9.37838C4.65373 8.54756 4.3748 7.58906 4.3748 6.60645C4.3748 3.69867 6.7475 1.32598 9.65527 1.32598C12.563 1.32598 14.9322 3.69867 14.9322 6.60645C14.9322 7.55992 14.6717 8.49391 14.1857 9.30708Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65527 3.44238C7.91061 3.44238 6.49121 4.86178 6.49121 6.60645C6.49121 8.33996 7.88751 9.77051 9.65527 9.77051C11.4448 9.77051 12.8193 8.32091 12.8193 6.60645C12.8193 4.86178 11.3999 3.44238 9.65527 3.44238ZM9.65527 8.72285C8.48608 8.72285 7.53887 7.77247 7.53887 6.60645C7.53887 5.44334 8.49216 4.49004 9.65527 4.49004C10.8184 4.49004 11.7682 5.44334 11.7682 6.60645C11.7682 7.75546 10.843 8.72285 9.65527 8.72285Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3308_653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.655273 0.27832)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.893ba517b6528f8ce717862d14134a3d.svg";
export { ForwardRef as ReactComponent };